import React, { useEffect, useState } from "react";
import { I18nTranslator, translations } from "utils/i18n";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { GridColDef } from "@mui/x-data-grid";
import { usePaginationRequest } from "hooks/useRequest";
import { IGetAllLocationsReportRequest, IEmptyLocationsReport } from "model";
import { ReportApiService } from "services";
import { isEmpty } from "lodash";

interface ILocationListProps {
  request: IGetAllLocationsReportRequest;
}

const NewLocation = (props: ILocationListProps) => {
  const { request } = props;
  const [getAllLocationRequest, setGetAllLocationRequest] = useState({
    ...request,
    pageNumber: 1,
    pageSize: 100,
  });

  const { loading, result } = usePaginationRequest<
    IGetAllLocationsReportRequest,
    IEmptyLocationsReport[]
  >(getAllLocationRequest, ReportApiService.getEmptyLocationsReport);
  useEffect(() => {
    setGetAllLocationRequest({ ...getAllLocationRequest, ...request });
  }, [request]);

  const handleChangePage = (pageNumber: number) => {
    setGetAllLocationRequest({
      ...getAllLocationRequest,
      pageNumber: pageNumber,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setGetAllLocationRequest({
      ...getAllLocationRequest,
      pageSize: pageSize,
    });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),

    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.report.zoneName),
      size: "medium",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "lineName",
      headerName: I18nTranslator(translations.report.lineName),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.report.locationName),
      size: "full",
    }),
  ];
  return (
    <AppTable<IEmptyLocationsReport>
      loading={loading}
      data={{
        ...result,
      }}
      columns={COLUMNS}
      actionColumnProps={{
        hideEdit: true,
      }}
      onSearch={(searchValue: string) => {}}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchReceiveDocument
      )}
      onChangePage={handleChangePage}
      hideHeader
      hideSearch
      removeActionColumn
      defaultHeaderTable={280}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default NewLocation;
